import { ROLE } from "@/data/role";
import { resolveApiUrl } from "@/data/url";

export default {
	methods: {
		getAvatarLink(link, defaultLink = '/images/camera-icon.png') {
			return !this.lodash.isEmpty(link) ? resolveApiUrl(`/api${link}`) : defaultLink
		},
		getDefaultAvatar(role) {
			return role == ROLE.CORP
				? "/images/manager/matching/matching1.png"
				: "/images/manager/matching/matching3.png";
		},
	},
}
